import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, ViewChild } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@shared/component.dialog';

@Component({
  selector: 'app-video-player',
  standalone: true,
  imports: [],
  templateUrl: './video-player.component.html',
  styleUrl: './video-player.component.scss'
})
export class VideoPlayerComponent implements AfterViewInit, OnDestroy {
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;

  video!: HTMLVideoElement;
  isVideoPlaying: boolean = false;

  constructor(
    @Inject(DIALOG_DATA) public data: { videoUrl: string },
    public readonly dialogRef: DialogRef
  ) { }

  ngAfterViewInit() {
    this.videoPlayer.nativeElement.volume = 1;
    this.video = this.videoPlayer.nativeElement;
    this.video.muted = true;
    document.body.classList.add('no-scroll');
  }

  onPlayClick() {
    this.isVideoPlaying = true;
    this.playVideo();
  }

   playVideo() {
    this.video.play().catch(() => {
      // Video playback may fail in environments without media support (e.g., headless Chrome).
      // Silently ignore — the user can still interact with the player UI.
    });
  }

  ngOnDestroy(): void {
    this.video.pause();
    document.body.classList.remove('no-scroll');
  }

  onClickClose() {
    this.dialogRef.close();
  }

}
